import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {WorkSignifier} from '@forecast-it/design-system';
import {ProjectIndicator_project$data} from './__generated__/ProjectIndicator_project.graphql';
import {useProjectIndicatorViewController} from './useProjectIndicatorViewController';

type ProjectIndicatorProps = {
	project?: ProjectIndicator_project$data;
	outline?: boolean;
};
const ProjectIndicator = ({project, outline = false}: ProjectIndicatorProps): React.JSX.Element => {
	const projectIndicatorData = useProjectIndicatorViewController(project);

	if (!projectIndicatorData) {
		return <></>; // temp fix until we fix the recent project dropdown that shows empty projects
	}

	const {workId, name, color} = projectIndicatorData;

	return <WorkSignifier workId={workId} name={name} color={color} outline={outline} />;
};

// Exported raw component to reuse it in ProjectIndicatorJS that wraps it in a JS fragment (since JS and TS fragments are incompatible)
export {ProjectIndicator as ProjectIndicatorNoFragment};

export default createFragmentContainer(ProjectIndicator, {
	project: graphql`
		fragment ProjectIndicator_project on ProjectType {
			name
			companyProjectId
			customProjectId
			projectColor
		}
	`,
});
